import React, { useEffect } from 'react'
import ListPhoto from './ListPhoto'
import {
  acquireBottomImmersive,
  releaseBottomImmersive,
} from '../utils/flutterStatusBar'

interface ReviewPeekOverlayProps {
  open: boolean
  reviewText?: string | null
  photos?: Array<{ id: string; preview: string }>
}

/**
 * A/B 비교 중 B 카드를 길게 누르는 동안 보여주는 "내 리뷰" 미리보기.
 * 전체화면이 아닌 가운데 작은 카드. 배경은 살짝 어둡게(터치는 통과 — 손 떼면 부모가 닫음).
 */
const ReviewPeekOverlay: React.FC<ReviewPeekOverlayProps> = ({
  open,
  reviewText,
  photos,
}) => {
  // 열려있는 동안 네이티브 하단 스트립(홈 인디케이터 영역)도 dim색으로 →
  // 웹 dim(inset-0)이 못 덮는 맨 아래까지 어둡게. (TermsModal 등과 동일)
  useEffect(() => {
    if (!open) return
    acquireBottomImmersive()
    return () => releaseBottomImmersive()
  }, [open])

  if (!open) return null

  const hasPhotos = !!photos && photos.length > 0
  const isEmpty = !hasPhotos && !reviewText

  const card = (
    <div className="relative w-full max-w-[320px] max-h-[70vh] overflow-y-auto scrollbar-hide bg-ivoryKey rounded-24px shadow-lg p-16px flex flex-col">
        {hasPhotos && (
          <div
            className="w-full flex gap-8px overflow-x-auto overflow-y-hidden scrollbar-hide mb-12px"
              style={{
                // overflow-x만 지정하면 CSS 규칙상 overflow-y가 visible→auto로 계산되어
                // 이 줄이 '세로 스크롤 컨테이너'가 된다. 세로로 1px만 넘쳐도 그 안에서
                // 스크롤이 소비되고 페이지로 전달되지 않아 화면이 안 움직인다.
                // 세로는 hidden으로 못 박고, 세로 제스처는 페이지가 받도록 둘 다 허용한다.
                touchAction: 'pan-x pan-y',
                overscrollBehaviorX: 'contain',
              }}
          >
            {photos!.map((p) => (
              <ListPhoto
                key={p.id}
                src={p.preview}
                alt=""
                className="flex-shrink-0 w-140px h-175px rounded-12px object-cover"
                draggable={false}
              />
            ))}
          </div>
        )}

        {reviewText && (
          <p className="font-pretendard font-regular text-15px leading-160% text-textColorText2">
            {reviewText}
          </p>
        )}

        {isEmpty && (
          <p className="py-16px font-pretendard font-regular text-14px text-textColorText3 text-center">
            남긴 리뷰 내용이 없어요
          </p>
        )}
    </div>
  )

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-32px pointer-events-none">
      <div className="absolute inset-0 bg-black bg-opacity-40" />
      {card}
    </div>
  )
}

export default ReviewPeekOverlay
